/**
 * 文言の引き方（03 4.1・3.7.1）。画面は code で分岐し、文言は辞書から取る（文言で分岐しない）。
 * 1. code があれば辞書（エラーコード）の文言
 * 2. 画面ごとの失敗の文言があり、code が 5xx 系（INTERNAL_ERROR・DYNAMODB_001）・通信の失敗なら画面ごとの文言（FE-D-039）
 * 3. 辞書に無い code は MSG-E-009「エラーが発生しました。」
 */
import { FE_MESSAGES, errorText, isErrorCode, isMessageId, t } from '@pcrm/shared';
import type { AnyMessageId } from '@pcrm/shared';
import { isApiError } from '../api/http-error';

export { t };

const SERVER_FAILURE_CODES = new Set(['INTERNAL_ERROR', 'DYNAMODB_001']);

export function messageOf(id: AnyMessageId, params: Readonly<Record<string, string | number>> = {}): string {
  return t(id, params);
}

/** Zod の message（MSG ID）→ 文言。ID でなければそのまま */
export function validationText(
  message: string | undefined,
  params: Readonly<Record<string, string | number>> = {},
): string | undefined {
  if (!message) {
    return undefined;
  }
  // `MSG-V-005|max=200` の形（lib/form-resolver.ts）なら差し込みの値を取り出す
  const [id = '', ...pairs] = message.split('|');
  const merged: Record<string, string | number> = { ...params };
  for (const pair of pairs) {
    const [name, value] = pair.split('=');
    if (name && value !== undefined) {
      merged[name] = value;
    }
  }
  if (!isMessageId(id)) {
    return message;
  }
  const text = t(id, merged);
  // 差し込みの値が無いまま残った文言（例 金額の形の誤りに当てた MSG-V-005「${max}文字以下…」）は、共通の入力の誤りの文言にする
  return text.includes('${') ? errorText('VALIDATION_001') : text;
}

export function errorMessageFor(error: unknown, screen_failure_id?: AnyMessageId): string {
  if (isApiError(error)) {
    if (error.code === 'TIMEOUT') {
      return FE_MESSAGES['FE-MSG-E-001'].text;
    }
    if (error.code === 'NETWORK') {
      return FE_MESSAGES['FE-MSG-E-002'].text;
    }
    if (screen_failure_id && SERVER_FAILURE_CODES.has(error.code)) {
      return t(screen_failure_id);
    }
    return isErrorCode(error.code) ? errorText(error.code) : t('MSG-E-009');
  }
  return screen_failure_id ? t(screen_failure_id) : t('MSG-E-009');
}

export function traceIdOf(error: unknown): string | undefined {
  return isApiError(error) ? error.trace_id : undefined;
}
